import { Directive, ViewContainerRef, TemplateRef, effect, inject, input } from '@angular/core';
import { TenantService } from '../../core/services/tenant.service';

@Directive({
  selector: '[appFeatureToggle]'
})
export class FeatureToggleDirective {
  private readonly templateRef = inject(TemplateRef);
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly tenantService = inject(TenantService);

  public readonly appFeatureToggle = input.required<string>();

  private hasView = false;

  constructor() {
    effect(() => {
      const featureId = this.appFeatureToggle();
      const org = this.tenantService.organization();
      
      const isEnabled = org?.enabledFeatures.includes(featureId) ?? false;

      if (isEnabled && !this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.hasView = true;
      } else if (!isEnabled && this.hasView) {
        this.viewContainer.clear();
        this.hasView = false;
      }
    });
  }
}
